function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0413 38L90.4086 46.2302L100.083 47.5946L93.0854 53.9763L94.729 63.0427L86.0413 58.7736L77.3535 63.0427L78.9971 53.9763L72 47.5946L81.7209 46.2302L86.0413 38Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1367 51.6437L90.4571 46.2302L86.1367 38V51.6437Z",
  fill: "url(#paint0_linear_992_15148)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9478 38L81.6274 46.2302L85.9478 51.6437V38Z",
  fill: "url(#paint1_linear_992_15148)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9009 51.687L81.7683 46.1415L72.0474 47.4619L85.9009 51.687Z",
  fill: "url(#paint2_linear_992_15148)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M72 47.6396L78.9972 54.0213L85.8535 51.8647L72 47.6396Z",
  fill: "url(#paint3_linear_992_15148)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9025 51.9084L78.9992 53.889L77.3086 62.9554L85.9025 51.9084Z",
  fill: "url(#paint4_linear_992_15148)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M77.4473 63.0434L86.135 58.7743L86.0411 51.9965L77.4473 63.0434Z",
  fill: "url(#paint5_linear_992_15148)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0896 51.9965L85.9487 58.7743L94.6365 63.0434L86.0896 51.9965Z",
  fill: "url(#paint6_linear_992_15148)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M94.7778 62.9554L93.1342 53.889L86.231 51.9084L94.7778 62.9554Z",
  fill: "url(#paint7_linear_992_15148)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.231 51.8207L93.0872 54.0213L100.084 47.6396L86.231 51.8207Z",
  fill: "url(#paint8_linear_992_15148)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M100.037 47.4619L90.3631 46.1415L86.1836 51.687L100.037 47.4619Z",
  fill: "url(#paint9_linear_992_15148)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M113.417 62L105 38H110.361L116.527 56.4734L122.639 38H128L119.529 62H113.417Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M131 38H136V62H131V38Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M150.382 38.002C151.517 37.978 152.645 38.1693 153.7 38.5647C154.756 38.9601 155.718 39.5516 156.529 40.3046C158.113 41.8436 159 43.9097 159 46.061C159 48.2124 158.113 50.2785 156.529 51.8175C155.718 52.5705 154.756 53.162 153.7 53.5574C152.645 53.9528 151.517 54.1441 150.382 54.1201H145.907V62H141V38.002H150.382ZM150.382 49.7196C150.878 49.7279 151.369 49.6364 151.825 49.4512C152.28 49.266 152.689 48.9912 153.024 48.6451C153.37 48.297 153.639 47.8868 153.815 47.4386C153.991 46.9904 154.07 46.5133 154.049 46.0355C154.08 45.0719 153.712 44.135 153.024 43.4259C152.678 43.0964 152.266 42.836 151.812 42.6603C151.359 42.4845 150.872 42.3968 150.382 42.4025H145.907V49.7196H150.382Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.42 25.4899C18.56 18.6299 16.76 13.4899 14.85 9.29993L11.33 10.9099C13.2726 14.7288 14.1304 19.0074 13.81 23.2799H7.45002C6.23002 23.2799 4.74002 22.9899 3.02002 20.8599L0.0200195 23.2799C2.15002 25.8999 4.52002 27.1299 7.47002 27.1299H17.17L17.42 25.4899Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1101 10.9799C27.1101 11.0499 30.4601 17.6599 28.1101 23.4899C26.7001 26.9399 23.5001 29.4899 18.6201 31.1599L19.8601 34.8099C25.8601 32.8099 29.8601 29.4599 31.7101 24.9099C34.7101 17.4399 30.7301 9.55991 30.5201 9.27991L27.1101 10.9799Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M40.81 18.35C40.81 17.3745 41.0994 16.421 41.6416 15.61C42.1837 14.7991 42.9543 14.1672 43.8557 13.7943C44.7571 13.4215 45.7489 13.3244 46.7055 13.5155C47.6621 13.7065 48.5405 14.177 49.2296 14.8675C49.9187 15.558 50.3874 16.4374 50.5765 17.3943C50.7656 18.3513 50.6665 19.3429 50.2919 20.2436C49.9172 21.1442 49.2837 21.9135 48.4717 22.454C47.6597 22.9945 46.7055 23.282 45.73 23.28C44.4286 23.28 43.1802 22.7644 42.2581 21.846C41.336 20.9277 40.8153 19.6814 40.81 18.38V18.35ZM45.73 9.63C43.515 9.71252 41.4138 10.6326 39.8509 12.2045C38.288 13.7764 37.3799 15.8828 37.3101 18.0983C37.2403 20.3138 38.0139 22.4732 39.4747 24.1404C40.9355 25.8075 42.9745 26.8582 45.18 27.08C42.5045 28.8469 39.5877 30.2177 36.52 31.15L37.74 34.81C54.26 29.4 54.6 20.42 54.52 18.75C54.52 18.61 54.52 18.48 54.52 18.35C54.5121 16.0231 53.5808 13.7946 51.9308 12.1539C50.2807 10.5133 48.0469 9.59468 45.72 9.6",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M151.59 4.27997C152 4.28191 152.402 4.16232 152.745 3.93627C153.088 3.71022 153.356 3.38782 153.515 3.00967C153.675 2.63153 153.72 2.21455 153.643 1.81126C153.566 1.40797 153.372 1.03641 153.084 0.743357C152.797 0.450309 152.429 0.248885 152.027 0.164458C151.626 0.0800307 151.208 0.116374 150.827 0.268912C150.446 0.421449 150.118 0.683358 149.886 1.02165C149.653 1.35994 149.526 1.75949 149.52 2.16997C149.516 2.4448 149.566 2.71768 149.668 2.97286C149.771 3.22803 149.922 3.46044 150.115 3.65664C150.307 3.85284 150.537 4.00895 150.79 4.11594C151.043 4.22293 151.315 4.27868 151.59 4.27997Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M151.59 17.09C150.837 17.086 150.103 16.8592 149.479 16.4382C148.855 16.0172 148.369 15.4207 148.084 14.7242C147.799 14.0277 147.726 13.2623 147.876 12.5245C148.025 11.7868 148.389 11.1098 148.923 10.5789C149.456 10.0481 150.135 9.68721 150.874 9.54181C151.612 9.39641 152.377 9.47302 153.072 9.76197C153.768 10.0509 154.361 10.5393 154.779 11.1654C155.197 11.7915 155.42 12.5273 155.42 13.28C155.415 14.2923 155.009 15.2614 154.291 15.9753C153.573 16.6892 152.602 17.09 151.59 17.09ZM159.21 13.28C159.223 11.6011 158.682 9.96474 157.672 8.6238C156.662 7.28287 155.238 6.31206 153.621 5.86145C152.003 5.41084 150.283 5.50553 148.724 6.13087C147.166 6.75621 145.858 7.87739 145.001 9.32108C144.143 10.7648 143.786 12.4506 143.983 14.1179C144.18 15.7852 144.921 17.3412 146.091 18.5453C147.261 19.7494 148.795 20.5346 150.456 20.7794C152.117 21.0243 153.812 20.7152 155.28 19.9C155.03 20.885 154.459 21.7584 153.656 22.3816C152.854 23.0049 151.866 23.3422 150.85 23.34H77.5799C78.4767 21.9923 78.9535 20.4088 78.9499 18.79V0H75.1599V18.79C75.1586 19.3888 75.0393 19.9815 74.8089 20.5343C74.5786 21.087 74.2416 21.589 73.8172 22.0115C73.3929 22.434 72.8894 22.7688 72.3357 22.9967C71.7819 23.2247 71.1887 23.3413 70.5899 23.34H67.2499C67.737 20.6251 67.5613 17.8328 66.7378 15.2003C65.9143 12.5679 64.4673 10.1733 62.5199 8.22L59.8299 10.88C61.4299 12.4852 62.5953 14.4711 63.2163 16.6509C63.8373 18.8306 63.8936 21.1325 63.3799 23.34H57.3799V27.11H151.52C153.61 26.9469 155.562 26.0037 156.988 24.4679C158.414 22.9322 159.211 20.916 159.22 18.82V13.56C159.22 13.46 159.22 13.37 159.22 13.28",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_992_15148",
  x1: 86.1367,
  y1: 44.8218,
  x2: 90.4571,
  y2: 44.8218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_992_15148",
  x1: 83.7876,
  y1: 51.6877,
  x2: 83.7876,
  y2: 38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_992_15148",
  x1: 78.9976,
  y1: 49.6185,
  x2: 80.1656,
  y2: 45.7016,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_992_15148",
  x1: 80.359,
  y1: 53.6252,
  x2: 77.8103,
  y2: 45.6896,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_992_15148",
  x1: 82.85,
  y1: 58.8623,
  x2: 79.0831,
  y2: 53.8266,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_992_15148",
  x1: 87.262,
  y1: 56.0455,
  x2: 76.34,
  y2: 59.3681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_992_15148",
  x1: 492.449,
  y1: 125.901,
  x2: 484.436,
  y2: 138.604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_992_15148",
  x1: 89.5182,
  y1: 51.4243,
  x2: 92.0415,
  y2: 68.9023,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_992_15148",
  x1: 92.9464,
  y1: 49.268,
  x2: 94.541,
  y2: 53.4771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_992_15148",
  x1: 98.3934,
  y1: 51.511,
  x2: 88.0142,
  y2: 47.2288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})));

function SvgVipLogoArabic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 64,
    viewBox: "0 0 160 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLogoArabic);
export default __webpack_public_path__ + "static/media/vip-logo-arabic.72bea428.svg";
export { ForwardRef as ReactComponent };